import { ThunkAction } from '../../store/types'
import * as actions from './actions'
import axios from 'axios'
import { DEPARTMENT_ID } from '../../constants'

export const fetchPhones = (): ThunkAction => {
  return async dispatch => {
    dispatch(actions.fetchPhonesRequest())

    try {
      const resp = await axios.get(`/public/footerInformation?departmentId=${DEPARTMENT_ID}`)
      dispatch(actions.fetchPhonesSuccess(resp.data))
    } catch (err) {
      dispatch(actions.fetchPhonesFail(err))
    }
  }
}
